import { __assign, __extends } from "tslib";
/* I89 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Move = /** @class */ (function (_super) {
    __extends(Move, _super);
    function Move() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Move.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
                    React.createElement("path", { d: "M12.832 7.707L11.57 8.97l2.265 2.265H1.889v1.777h11.946l-2.265 2.266 1.262 1.261 4.416-4.416z" }),
                    React.createElement("path", { d: "M19 18V6H5v3.76H3V4h17.994v.947H21v14.995h-.105V20H3v-6h2v4h14z" })))));
    };
    return Move;
}(React.Component));
export { Move };
export default Move;
//# sourceMappingURL=Move.js.map